<ag-grid-angular
  class="ag-theme-alpine custom-grid w-full"
  [rowData]="rowData"
  [columnDefs]="colDefs"
  (gridReady)="onGridReady($event)"
  (rowSelected)="onRowSelected($event)" 
  [suppressRowClickSelection]="true"
  [pagination]="true"
  [paginationPageSize]="pageSize"
  [domLayout]="'autoHeight'"
  [suppressPaginationPanel]="true"
  [suppressCellFocus]="true"
  [rowHeight]="70"
  rowSelection="single"
>
</ag-grid-angular>

<div class="flex justify-between items-center gap-2 py-4" *ngIf="pages.length > 1">
  <span 
    class="flex border border-gray-300 rounded-lg gap-1 py-2 px-3 cursor-pointer" 
    (click)="onPrevious()"
    [class.opacity-50]="currentPage === 0"
  >
    <img [src]="assetUrl + 'icons/arrow-left-20.svg'" alt="">
    Previous
  </span>

  <div class="flex gap-1">
    <ng-container *ngFor="let page of pages">
      <button 
        (click)="goToPage(page - 1)" 
        [class.active]="currentPage === page - 1"
        class="pagination-btn cursor-pointer"
      >
        {{ page }}
      </button>
    </ng-container>
  </div>

  <span 
    class="flex border border-gray-300 rounded-lg gap-1 py-2 px-3 cursor-pointer" 
    (click)="onNext()"
    [class.opacity-50]="currentPage === totalPages - 1"
  >
    Next
    <img [src]="assetUrl + 'icons/arrow-right-20.svg'" alt="">
  </span>                
</div>
